import { render, staticRenderFns } from "./teaUserScreenDetails.vue?vue&type=template&id=28b79214&scoped=true"
import script from "./teaUserScreenDetails.vue?vue&type=script&lang=js"
export * from "./teaUserScreenDetails.vue?vue&type=script&lang=js"
import style0 from "./teaUserScreenDetails.vue?vue&type=style&index=0&id=28b79214&prod&lang=scss&scoped=true"
import style1 from "./teaUserScreenDetails.vue?vue&type=style&index=1&id=28b79214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b79214",
  null
  
)

export default component.exports